/** @jsxImportSource @emotion/react */
import { Box, Breadcrumbs, Link as MuiLink, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

interface BreadcrumbLink {
  label: string
  path?: string
}
interface BreadcrumbComponentProps {
  links: BreadcrumbLink[]
}

const GuideBreadcrumbs: React.FC<BreadcrumbComponentProps> = ({ links }) => {
  return (
    <Box
      sx={{ height: 40, width: '100%', bgcolor: 'white', display: 'flex', alignItems: 'center' }}
    >
      <Box
        sx={{
          height: 1,
          display: { xs: 'none', md: 'flex' },
          alignItems: 'center',
          maxWidth: 1184,
          width: 1,
        }}
      >
        <Breadcrumbs
          aria-label="breadcrumb"
          separator="›"
          sx={{
            width: 1,
            '& .MuiBreadcrumbs-ol': { display: 'flex', flexWrap: 'nowrap', minWidth: 0 },
            '& .MuiBreadcrumbs-li': { minWidth: 0, whiteSpace: 'nowrap' },
            '& .MuiBreadcrumbs-li:last-child': { flex: 1, minWidth: 0 },
            '& .MuiBreadcrumbs-li:last-child > *': {
              display: 'block',
              minWidth: 0,
              maxWidth: '70%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          }}
        >
          {/* Home */}
          <MuiLink
            component={RouterLink}
            to="/app/guide/overview"
            underline="hover"
            color="inherit"
            sx={{ color: '#2f85f6' }}
          >
            <Typography>Home</Typography>
          </MuiLink>

          {/* Dynamic */}
          {links?.map((link, i) => {
            const isLast = i === links.length - 1 || !link.path
            return isLast ? (
              <Typography key={i} color="text.primary" title={link.label}>
                {link.label}
              </Typography>
            ) : link.path ? (
              <MuiLink
                key={i}
                component={RouterLink}
                to={link.path as string}
                underline="hover"
                color="#2f85f6"
              >
                {link.label}
              </MuiLink>
            ) : null
          })}
        </Breadcrumbs>
      </Box>
    </Box>
  )
}

export default GuideBreadcrumbs
